import React from "react";

interface IBreachBoxDescription {
    title: string;
    description: any;
}

function BreachBoxDescription({ title, description }: IBreachBoxDescription) {
    return (
        <div className="box-description" style={{ paddingLeft: "0.7rem" }}>
            <h3>{title}</h3>
            <p className="padding-bottom-xs breach-exposure-desc">{description}</p>
        </div>
    );
}

export default BreachBoxDescription;
